// audio.ts
export const incomingCallAudio = new Audio('/media/audio/ringtone.mp3');
incomingCallAudio.loop = true;

export const unlockAudio = () => {
  incomingCallAudio.play().then(() => {
    incomingCallAudio.pause();
    incomingCallAudio.currentTime = 0;
  }).catch(() => {
    // User gesture required — will retry on first click
  });
};